import { dataelementAPI } from 'api/dataelement';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { locales } from 'utils/constants';

export function useDeleteDataelement() {
  const mutation = useMutation({
    mutationFn: dataelementAPI.delete,
    onSuccess: () => {
      toast(locales.deleteSuccess, { type: 'success' });
    },
  });

  return mutation;
}
